import { Component } from '@angular/core';

@Component({
  selector: 'app-aviso-privacidad',
  templateUrl: './aviso-privacidad.component.html',
  styleUrls: ['./aviso-privacidad.component.scss']
})
export class AvisoPrivacidadComponent {
  icons = {
    logo: 'assets/icons/logo.svg',
    perfil: 'assets/icons/perfil.svg',
    whitelogo: 'assets/icons/white-icon.svg',
    bars: 'assets/icons/bars.svg',
    sphere3: 'assets/images/sphere-3.png',
    sphere1: 'assets/images/sphere-1.png',
    whatsapp: 'assets/images/whatsapp.svg'
  }

  openWhatsApp() {
    const phone = '+523314115507';
    const message = encodeURIComponent('Hola. Me podrías dar más información de DRAM');
    window.open(`https://wa.me/${phone.replace('+', '')}?text=${message}`, '_blank');
  }
}
